import {jwtDecode} from 'jwt-decode';

export interface DecodedToken {
  id:string;
  email: string;
  profile_picture:string;
  name:string;
  slug:string;
  position:string;

}
export const decodeToken = (token: string): DecodedToken => {
  return jwtDecode<DecodedToken>(token);
};
